import React from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { GridWrapperStyled } from './styled';
export function ProductPricingInfoSkeleton() {
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    return (React.createElement(GridWrapperStyled, { containerProps: {
            mdIndentReset: !isInfiniteDesktopView,
            smIndentReset: !isInfiniteDesktopView,
        } },
        React.createElement(FlexWrapper, { flexDirection: "column", paddingMobile: "40px 24px 48px 16px", paddingTablet: "64px 24px 72px 24px", paddingDesktop: "64px 0px 72px 0px" },
            React.createElement(Skeleton, { skeletonProps: {
                    height: 28,
                    width: 200,
                } }),
            React.createElement(Skeleton, { skeletonProps: {
                    height: isMobileView ? 140 : 100,
                }, wrapperProps: {
                    isFullWidth: true,
                    mtS: 16,
                } }),
            React.createElement(Skeleton, { skeletonProps: {
                    height: isMobileView ? 140 : 100,
                }, wrapperProps: {
                    isFullWidth: true,
                    mtS: 16,
                } }))));
}
